angular.module('bmsApp.global').factory('ReminderSvc', function ($rootScope,
																 $modal,
																 notify,
																 CRUDSvc) {

	return {
		typeOptions: function () {
			return CRUDSvc.get('api/reminder/type/options');
		},
		saveReminder: function (reminder) {
			return CRUDSvc.post('api/reminder/save', reminder);
		},
		showReminderModal: function (remindable_type, remindable_id) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/reminder/templates/ReminderModal.html',
				controller: 'ReminderModalCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					remindable_type: function () {
						return remindable_type;
					},
					remindable_id: function () {
						return remindable_id;
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Reminder queued successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});
		}
	};

});
